/*
 * rheincool — Formular-Komfort (Beratung + Wartungs-Anfrage)
 * - Query-Param-Prefill: [data-prefill-param="anliegen"] übernimmt den
 *   gleichnamigen URL-Parameter (Planer-/CTA-Übergabe, HANDOFF §5.6)
 * - Fehlerzustand: ungültige Pflichtfelder bekommen .has-error + deutsche
 *   Meldung (Browser-Validation bleibt aktiv)
 */
(() => {
  'use strict';

  const params = new URLSearchParams(window.location.search);

  document.querySelectorAll('[data-prefill-param]').forEach((field) => {
    const value = params.get(field.dataset.prefillParam);
    if (!value) return;
    if (field.tagName === 'SELECT') {
      const option = Array.from(field.options).find((o) => o.value === value);
      if (option) field.value = value;
    } else {
      field.value = value;
    }
  });

  document.querySelectorAll('form[data-lead-form]').forEach((form) => {
    form.addEventListener(
      'invalid',
      (event) => {
        event.target.closest('.rc-form__group')?.classList.add('has-error');
      },
      true
    );
    form.addEventListener('input', (event) => {
      if (event.target.checkValidity()) {
        event.target.closest('.rc-form__group')?.classList.remove('has-error');
      }
    });
    form.addEventListener('submit', () => {
      if (window.rcTrack) {
        window.rcTrack('consult_cta_click', {
          quelle: form.dataset.leadForm,
          anliegen: form.querySelector('[name="contact[Anliegen]"]')?.value || '',
        });
      }
    });
  });
})();
